var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0Zm6.314 8.67c-.241.18-.27.375-.27.634.003 3.502-2.184 6.831-5.342 8.145-2.64 1.099-5.863.868-8.246-.643.869.014 1.644-.03 2.394-.255a6.18 6.18 0 0 0 2.069-1.049c-1.63-.36-2.43-.965-2.826-2.135.426-.059.868.075 1.278-.114-1.607-.618-2.473-1.71-2.398-3.047.42.17.837.329 1.343.346-1.348-1.145-1.687-2.494-.935-4.153.37.439.776.845 1.216 1.213 1.465 1.202 3.144 1.87 5.031 2.035.213.02.206-.043.186-.223-.18-1.64.688-3 2.187-3.45.167-.05.341-.07.512-.105.247.04.5.04.746-.003a2.89 2.89 0 0 1 1.744.786c.15.141.274.157.464.11.56-.135 1.082-.366 1.667-.65-.228.717-.654 1.191-1.247 1.614.602.018 1.088-.21 1.657-.384a4.969 4.969 0 0 1-1.23 1.328Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b11399ee6b54c49fd9ecf53d497e78af.svg";
export { ForwardRef as ReactComponent };